
const API_URL = 'https://98fzfcf5hk.execute-api.eu-west-3.amazonaws.com/v2';

const recordCache = {};

const handleError = (error) => {
    if (error.status === 401) {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        window.location.href = '/login';
        throw new Error('Sesión expirada');
    }
    throw error;
};

const addCredentialsToBody = (data) => {
    const token = localStorage.getItem('token');
    const email = localStorage.getItem('user');
    return { ...data, token, email };
};

export const dataProvider = {

    getList: async (resource, params) => {
        const token = localStorage.getItem('token');
        if (!token) throw new Error('No hay token de autenticación');

        const { page, perPage } = params.pagination;
        const { field, order } = params.sort;

        const url = new URL(`${API_URL}/${resource}`);
        url.searchParams.append('page', page);
        url.searchParams.append('per_page', perPage);
        url.searchParams.append('sort_by', field);
        url.searchParams.append('order', order.toLowerCase());

        const email = localStorage.getItem('email') || '';
        url.searchParams.append('email', email);

        if (params.filter) {
            Object.keys(params.filter).forEach(key => {
                url.searchParams.append(key, params.filter[key]);
            });
        }

        try {
            const response = await fetch(url.toString(), {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
            });

            if (!response.ok) throw new Error(`Error: ${response.status}`);

            const responseData = await response.json();

            if (resource === 'available_purchases') {
                console.log('available_purchases response:', responseData);
                const dataWithIds = responseData.data.map((item, index) => ({
                    ...item,
                    id: item.product_id + '_' + item.sku || `item_${index}`
                }));
                return {
                    data: dataWithIds,
                    total: responseData.total || responseData.data.length,
                };
            } else {
                const { data, total } = responseData;
                if (data && Array.isArray(data)) {
                    if (!recordCache[resource]) recordCache[resource] = {};
                    data.forEach(record => {
                        if (record.id !== undefined) {
                            recordCache[resource][record.id] = record;
                        }
                    });
                }
                return { data, total };
            }
        } catch (error) {
            console.error('DataProvider error:', error);
            handleError(error);
        }
    },

    update: async (resource, params) => {
        console.log('UPDATE called with:', { resource, params });

        const url = `${API_URL}/${resource}/${params.id}`;
        const token = localStorage.getItem('token') || sessionStorage.getItem('token');

        const options = {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
            body: JSON.stringify(params.data),
        };

        console.log('UPDATE request:', { url, options });

        return fetch(url, options)
            .then(response => {
                console.log('UPDATE response status:', response.status);
                if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
                return response.json();
            })
            .then(json => {
                console.log('UPDATE response json:', json);
                if (json.data && json.data.id) return { data: json.data };
                if (json.id) return { data: json };
                throw new Error(`Response does not contain valid data structure. Received: ${JSON.stringify(json)}`);
            })
            .catch(error => {
                console.error('UPDATE error:', error);
                throw new Error(`Update failed: ${error.message}`);
            });
    },

    create: (resource, params) => {
        console.log('CREATE called with:', { resource, params });

        const url = `${API_URL}/${resource}`;
        const token = localStorage.getItem('token') || sessionStorage.getItem('token');

        const options = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
            body: JSON.stringify(params.data),
        };

        console.log('CREATE request:', { url, options });

        return fetch(url, options)
            .then(response => {
                console.log('CREATE response status:', response.status);
                if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
                return response.json();
            })
            .then(json => {
                console.log('CREATE response json:', json);
                if (json.data && json.data.id) return { data: json.data };
                if (json.id) return { data: json };
                throw new Error(`Create response does not contain valid data structure. Received: ${JSON.stringify(json)}`);
            })
            .catch(error => {
                console.error('CREATE error:', error);
                throw new Error(`Create failed: ${error.message}`);
            });
    },

    getOne: async (resource, params) => {
        console.log('GET_ONE called with:', { resource, params });

        const token = localStorage.getItem('token') || sessionStorage.getItem('token');
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        };

        try {
            const response = await fetch(`${API_URL}/${resource}/${params.id}`, {
                method: 'GET',
                cache: 'no-store',
                headers,
            });

            if (!response.ok) {
                const err = new Error(`HTTP error! status: ${response.status}`);
                err.status = response.status;
                throw err;
            }

            const json = await response.json();
            console.log('GET_ONE response json:', json);

            let record;
            if (json.data && typeof json.data === 'object') {
                record = json.data;
            } else if (json.id !== undefined) {
                record = json;
            } else {
                throw new Error('GetOne: formato de respuesta inválido.');
            }

            if (!recordCache[resource]) recordCache[resource] = {};
            recordCache[resource][params.id] = record;
            return { data: record };

        } catch (error) {
            console.warn(`GET_ONE ${resource}/${params.id} failed:`, error.message);

            if (recordCache[resource]?.[params.id]) {
                console.log(`GET_ONE: usando caché para ${resource}/${params.id}`);
                return { data: recordCache[resource][params.id] };
            }

            if (!error.status) error.status = 0;
            throw error;
        }
    },

    delete: async (resource, params) => {
        const token = localStorage.getItem('token');
        const bodyWithCredentials = addCredentialsToBody({});

        try {
            const response = await fetch(`${API_URL}/${resource}/${params.id}`, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify(bodyWithCredentials),
            });

            if (!response.ok) throw new Error(`Error: ${response.status}`);

            if (recordCache[resource]) {
                delete recordCache[resource][params.id];
            }

            return { data: params.previousData };
        } catch (error) {
            handleError(error);
        }
    },

    deleteMany: async (resource, params) => {
        const token = localStorage.getItem('token');

        console.log('Token:', token);
        console.log('User:', localStorage.getItem('user'));
        console.log('Email:', localStorage.getItem('email'));

        const bodyWithCredentials = addCredentialsToBody({ ids: params.ids });
        const email = localStorage.getItem('email') || localStorage.getItem('user');
        const requestBody = { ...bodyWithCredentials, ids: params.ids, email };

        try {
            const response = await fetch(`${API_URL}/${resource}/bulk-delete`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify(requestBody),
            });

            console.log('[deleteMany] response status:', response.status);
            try {
                console.log('[deleteMany] response headers:', Array.from(response.headers.entries()));
            } catch (hErr) {
                console.log('[deleteMany] could not read headers', hErr);
            }

            if (response.status === 401) {
                console.warn('[deleteMany] 401 Unauthorized');
                throw new Error('Sesión expirada');
            }

            if (!response.ok) {
                let errorText = '';
                try {
                    errorText = await response.text();
                    console.error('[deleteMany] error response body:', errorText);
                } catch (readErr) {
                    console.error('[deleteMany] failed to read error body', readErr);
                }
                throw new Error(`Error: ${response.status}${errorText ? ' - ' + errorText : ''}`);
            }

            let data;
            try {
                data = await response.json();
                console.log('[deleteMany] parsed JSON response:', data);
            } catch (e) {
                console.warn('[deleteMany] response is not JSON, falling back to params.ids', e);
                data = params.ids;
            }

            try {
                let returnedIds;
                if (Array.isArray(data)) {
                    returnedIds = data.map(item => (item && typeof item === 'object' ? (item.id ?? item) : item));
                } else if (data && Array.isArray(data.data)) {
                    returnedIds = data.data.map(item => (item && typeof item === 'object' ? (item.id ?? item) : item));
                } else if (data && Array.isArray(data.ids)) {
                    returnedIds = data.ids;
                } else if (data && (data.id || typeof data.id === 'number')) {
                    returnedIds = [data.id];
                } else if (Array.isArray(params.ids)) {
                    returnedIds = params.ids;
                } else {
                    returnedIds = [data];
                }
                data = returnedIds;
                console.log('[deleteMany] normalized deleted IDs:', data);
            } catch (normErr) {
                console.error('[deleteMany] failed to normalize response', normErr);
                data = params.ids;
            }

            return { data };
        } catch (error) {
            handleError(error);
        }
    },

    getMany: async (resource, params) => {
        const token = localStorage.getItem('token');
        const query = params.ids.map(id => `id=${id}`).join('&');

        try {
            const response = await fetch(`${API_URL}/${resource}?${query}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
            });

            if (!response.ok) throw new Error(`Error: ${response.status}`);

            const { data } = await response.json();
            return { data };
        } catch (error) {
            handleError(error);
        }
    },

    getManyReference: async (resource, params) => {
        const token = localStorage.getItem('token');
        const { page, perPage } = params.pagination;
        const { field, order } = params.sort;

        const url = new URL(`${API_URL}/${resource}`);
        url.searchParams.append(params.target, params.id);
        url.searchParams.append('page', page);
        url.searchParams.append('per_page', perPage);
        url.searchParams.append('sort_by', field);
        url.searchParams.append('order', order.toLowerCase());

        try {
            const response = await fetch(url.toString(), {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
            });

            if (!response.ok) throw new Error(`Error: ${response.status}`);

            const { data, total } = await response.json();
            return { data, total };
        } catch (error) {
            handleError(error);
        }
    },
};